import {Component, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Subscription} from 'rxjs';
import {UsersService} from '../../../core/services/users.service';
import {ShadeToolsService} from '../../../core/services/shade-tools.service';
import {ActivatedRoute, RouterLink} from '@angular/router';
import {HttpErrorResponse} from '@angular/common/http';
import {UserInvitation} from '../../../shared/models/invitations';
import {NewUser} from '../../../shared/models/user';
import {SpinnerComponent} from '../../components/spinner/spinner.component';
import {FormsModule} from '@angular/forms';
import {LoginHelpButtonsComponent} from '../../components/login-help-buttons/login-help-buttons.component';
import {NgClass} from '@angular/common';
import {PillComponent} from '../../components/pill/pill.component';
import {UtilsService} from '../../../core/services/utils.service';

@Component({
  selector: 'motn-user-registration',
  templateUrl: './user-registration.component.html',
  styleUrls: ['./user-registration.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    SpinnerComponent,
    FormsModule,
    LoginHelpButtonsComponent,
    NgClass,
    PillComponent,
    RouterLink,
  ],
})
export class UserRegistrationComponent implements OnInit, OnDestroy {
  checkingCode: boolean = true;
  invalidCode: boolean = false;
  code: string = '';

  invitation: UserInvitation;
  newUser: NewUser = {
    Code: '',
    Email: '',
    Name: '',
    Password: '',
    PasswordConfirm: '',
    Username: '',
  };

  agreeToEula: boolean = false;
  submitting: boolean = false;
  succeeded: boolean = false;

  routeSub: Subscription;


  constructor(
    private userService: UsersService,
    private shadeTools: ShadeToolsService,
    private route: ActivatedRoute,
  ) {
  }


  ngOnInit(): void {
    this.route.queryParams.subscribe(
      (params) => {
        this.code = params['code'];

        this.checkCode();
      },
    );
  }


  ngOnDestroy() {
    this.routeSub?.unsubscribe();
  }



  register() {
    for (let prop of Object.values(this.newUser)) {
      if (!prop) {
        this.shadeTools.errorDialog('Please fill in all the fields before submitting.');
        return;
      }
    }

    if (!this.agreeToEula) {
      this.shadeTools.errorDialog('Please read the EULA and indicate that you agree to its terms before submitting.');
      return;
    }

    if (this.newUser.Password !== this.newUser.PasswordConfirm) {
      this.shadeTools.errorDialog('Passwords do not match.');
      return;
    }

    this.submitting = true;

    this.userService.createNewUser$(this.newUser).subscribe({
      next: () => {
        this.succeeded = true;
      },
      error: (err: HttpErrorResponse) => {
        let dlgMsg: string = 'An error occurred while creating your account.';

        const errorDetail = UtilsService.extractErrorMessage(err.error);
        if (errorDetail) {

          // Handle different error messages based on the detail content
          if (errorDetail.includes('username not available')) {
            dlgMsg = 'The username you chose is not available. Please try another username.';
          } else if (errorDetail.includes('username is too long')) {
            dlgMsg = 'The username you chose is too long.';
          } else if (errorDetail.includes('username is too short')) {
            dlgMsg = 'The username you chose is too short.';
          } else if (errorDetail.includes('username') && errorDetail.includes('invalid characters')) {
            dlgMsg = 'The username you chose contains invalid characters. Only letters, numbers, hyphens, and underscores are permitted.';
          } else if (errorDetail.includes('password')) {
            dlgMsg = 'Password must be at least 10 characters long.';
          } else if (errorDetail.includes('email') || errorDetail.includes('mail')) {
            dlgMsg = 'The email address you provided is not valid.';
          } else if (errorDetail.includes('name is too short')) {
            dlgMsg = 'The full name you provided is too short.';
          } else if (errorDetail.includes('name is too long')) {
            dlgMsg = 'The full name you provided exceeds the maximum of 50 characters.';
          }
        }

        this.shadeTools.errorDialog(dlgMsg);
        this.submitting = false;
      }
    });
  }


  private checkCode() {
    this.userService.fetchUserInvitation$(this.code).subscribe(
      (invite) => {
        this.invitation = invite;

        this.newUser.Code = invite.Code;
        this.newUser.Name = invite.InviteeName;
        this.newUser.Email = invite.InviteeEmail;

        this.checkingCode = false;
      },
      (err: HttpErrorResponse) => {
        if (err.status === 404) {
          this.invalidCode = true;
        } else {
          this.shadeTools.errorDialog();
        }

        this.checkingCode = false;
      },
    );
  }
}
